<app-relatorio-container
    tituloRelatorio="Certidão de Responsabilidade Técnica (CART)"
    descricaoRelatorio="Certidão de anotação de responsabilidade técnica do prestador."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'cart-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-color-secondary m-0">A certidão é emitida para o prestador selecionado, utilizando os dados do diretor técnico cadastrado. Informe o número, o ano e a validade da certidão.</p>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="field">
                    <label for="numero" class="font-semibold block mb-2">Número</label>
                    <input id="numero" pInputText formControlName="numero" class="w-full" placeholder="Ex.: 123" />
                    @if (form.get('numero')?.invalid && form.get('numero')?.touched) {
                        <small class="p-error mt-2" style="color: red">Informe o número.</small>
                    }
                </div>

                <div class="field">
                    <label for="ano" class="font-semibold block mb-2">Ano</label>
                    <input id="ano" pInputText formControlName="ano" class="w-full" placeholder="Ex.: 2026" />
                    @if (form.get('ano')?.invalid && form.get('ano')?.touched) {
                        <small class="p-error mt-2" style="color: red">Informe o ano.</small>
                    }
                </div>

                <div class="field">
                    <label for="validade" class="font-semibold block mb-2">Validade</label>
                    <p-date-picker inputId="validade" formControlName="validade" dateFormat="dd/mm/yy" [showIcon]="true" [showButtonBar]="true" styleClass="w-full" appendTo="body" placeholder="dd/mm/aaaa"></p-date-picker>
                    @if (form.get('validade')?.invalid && form.get('validade')?.touched) {
                        <small class="p-error mt-2" style="color: red">Informe a validade.</small>
                    }
                </div>

                <div class="field">
                    <label for="coordenador" class="font-semibold block mb-2">Coordenador</label>
                    <input id="coordenador" pInputText formControlName="coordenador" class="w-full" placeholder="Nome do coordenador (opcional)" />
                </div>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Certidão" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending || form.invalid"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
